export const DRIVE_DEPARTMENTS = {
  SOTT: "SOTT",
  INNL: "INNL",
  INNF: "INNF",
  UTFL: "UTFL"
};
